import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import { showSuccessMsg, showAlertMsg } from '../../util/messagesUtil';
import cadastrarRegraControleEmissaoBpe from '../../actions/bpe/cadastrarRegraControleEmissaoBpe';
import buscarEmpresaPorId from '../../actions/empresa/buscarEmpresaPorId';
import cadastrarControleEmissaoBpeUsuario from '../../actions/bpe/cadastrarControleEmissaoBpeUsuario';
import listarControleEmissaoBpeUsuario from '../../actions/bpe/listarControleEmissaoBpeUsuario';
import excluirControleEmissaoBpeUsuario from '../../actions/bpe/excluirControleEmissaoBpeUsuario';
import buscarUsuarioPorEmpresaNomeIdEmail from '../../actions/usuario/buscarUsuarioEmpresaPorParte';
import buscarDiasSemanaControleEmissaoBpe from '../../actions/bpe/buscarDiasSemanaControleEmissaoBpe';
import buscarRotasControleEmissaoBpe from '../../actions/bpe/buscarRotasControleEmissaoBpe';
import buscarRotas from '../../actions/rota/buscarRotas';
import { formasPagamentoControleEmissaoBpe, tipoControleEmissaoBPe } from '../../util/constantsUtil';
import Select from 'react-select';
import $ from 'jquery';
import ReactTooltip from 'react-tooltip';

const DIAS_SEMANA = [
  { label: 'Dom', descricao: 'Domingo', value: 'SUNDAY' },
  { label: 'Seg', descricao: 'Segunda-feira', value: 'MONDAY' },
  { label: 'Ter', descricao: 'Terça-feira', value: 'TUESDAY' },
  { label: 'Qua', descricao: 'Quarta-feira', value: 'WEDNESDAY' },
  { label: 'Qui', descricao: 'Quinta-feira', value: 'THURSDAY' },
  { label: 'Sex', descricao: 'Sexta-feira', value: 'FRIDAY' },
  { label: 'Sab', descricao: 'Sábado', value: 'SATURDAY' },
];

const ordemDia = dia => DIAS_SEMANA.findIndex(it => it.value === dia);

const FORMAS_PAGAMENTO_ROTA = formasPagamentoControleEmissaoBpe;

const ehRegraHorario = tipo => tipo === tipoControleEmissaoBPe.horario.value
  || tipo === tipoControleEmissaoBPe.horarioMaisCartao.value;

const descricaoFormasPagamento = tiposPagamento => FORMAS_PAGAMENTO_ROTA
  .filter(it => tiposPagamento.includes(it.value))
  .map(it => it.label)
  .join(', ');

export class ModalPainelRegraControleEmissaoBpe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usuarioEmpresaSelecionado: null,
      tiposPagamentoSelecionados: [],
      usuarios: [],
      carregandoUsuarios: false,
      diasSemana: [],
      novosHorarios: {},
      rotasEmpresa: [],
      rotaSelecionada: null,
      tiposPagamentoRota: [],
      rotasConfiguradas: [],
      usuariosConfigurados: [],
      usuariosOriginais: []
    };
    this.submit = this.submit.bind(this);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.handleUsuarioChange = this.handleUsuarioChange.bind(this);
    this.handleTipoPagamentoChange = this.handleTipoPagamentoChange.bind(this);
    this.buscarUsuarios = this.buscarUsuarios.bind(this);
    this.carregarDiasSemana = this.carregarDiasSemana.bind(this);
    this.carregarRotas = this.carregarRotas.bind(this);
    this.carregarUsuariosConfigurados = this.carregarUsuariosConfigurados.bind(this);
  }

  componentDidMount() {
    // Recarrega os dias salvos a cada abertura, descartando edições não salvas
    $('#modalPainelRegraControleEmissaoBpe').on('show.bs.modal', this.carregarDiasSemana);
    $('#modalPainelRegraControleEmissaoBpe').on('show.bs.modal', this.carregarRotas);
    $('#modalPainelRegraControleEmissaoBpe').on('show.bs.modal', this.carregarUsuariosConfigurados);
  }

  componentWillUnmount() {
    $('#modalPainelRegraControleEmissaoBpe').off('show.bs.modal', this.carregarDiasSemana);
    $('#modalPainelRegraControleEmissaoBpe').off('show.bs.modal', this.carregarRotas);
    $('#modalPainelRegraControleEmissaoBpe').off('show.bs.modal', this.carregarUsuariosConfigurados);
  }

  // Recarrega os usuários já configurados a cada abertura, descartando alterações não salvas
  carregarUsuariosConfigurados() {
    const empresaId = this.props.codigoEmpresaSelecionada;
    this.setState({
      usuariosConfigurados: [], usuariosOriginais: [], usuarioEmpresaSelecionado: null, tiposPagamentoSelecionados: []
    });
    if (!empresaId) {
      return;
    }
    this.props.listarControleEmissaoBpeUsuario(empresaId)
      .then(response => {
        const data = response.payload.data || [];
        const usuarios = Array.isArray(data) ? data.map(it => ({
          id: it.id,
          usuarioEmpresaId: it.usuarioEmpresaId,
          descricaoUsuario: `${it.nomeUsuario || ''} (${it.emailUsuario || ''})`,
          tiposPagamento: it.tiposPagamento || []
        })) : [];
        this.setState({ usuariosConfigurados: usuarios, usuariosOriginais: usuarios });
      })
      .catch(() => {
        // mensagem de erro já exibida pelo interceptor de resposta
      });
  }

  incluirUsuario() {
    const { usuarioEmpresaSelecionado, tiposPagamentoSelecionados, usuariosConfigurados } = this.state;
    if (!usuarioEmpresaSelecionado || !usuarioEmpresaSelecionado.value) {
      showAlertMsg('Selecione um usuário.');
      return;
    }
    if (tiposPagamentoSelecionados.length === 0) {
      showAlertMsg('Selecione ao menos uma forma de pagamento.');
      return;
    }
    const novoUsuario = {
      usuarioEmpresaId: usuarioEmpresaSelecionado.value,
      descricaoUsuario: usuarioEmpresaSelecionado.label,
      tiposPagamento: [...tiposPagamentoSelecionados]
    };
    const jaIncluido = usuariosConfigurados.some(it => it.usuarioEmpresaId === novoUsuario.usuarioEmpresaId);
    this.setState({
      usuariosConfigurados: jaIncluido
        ? usuariosConfigurados.map(it => (it.usuarioEmpresaId === novoUsuario.usuarioEmpresaId ? { ...it, ...novoUsuario } : it))
        : [...usuariosConfigurados, novoUsuario],
      usuarioEmpresaSelecionado: null,
      tiposPagamentoSelecionados: [],
      usuarios: []
    });
    if (jaIncluido) {
      showSuccessMsg('Usuário já incluído: formas de pagamento atualizadas.');
    }
  }

  removerUsuario(usuarioEmpresaId) {
    this.setState({ usuariosConfigurados: this.state.usuariosConfigurados.filter(it => it.usuarioEmpresaId !== usuarioEmpresaId) });
  }

  exibirConfiguracaoPorUsuario() {
    const {
      usuarios, usuarioEmpresaSelecionado, carregandoUsuarios, tiposPagamentoSelecionados, usuariosConfigurados
    } = this.state;
    return (
      <div className="vx-modal-section">
        <div className="vx-modal-section-title">
          <i className="material-icons">person</i>Usuários e Formas de Pagamento
        </div>
        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Usuário</label>
        <Select
          maxMenuHeight={200}
          menuPlacement="auto"
          noOptionsMessage={() => ('Digite pelo menos 2 caracteres para buscar')}
          placeholder='Digite para buscar usuário...'
          options={usuarios}
          value={usuarioEmpresaSelecionado}
          onChange={this.handleUsuarioChange}
          onInputChange={this.buscarUsuarios}
          isLoading={carregandoUsuarios}
        />
        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', margin: '12px 0 4px' }}>Formas de pagamento que emitem BPe</label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center' }}>
          {FORMAS_PAGAMENTO_ROTA.map(it => (
            <div key={it.value} className="form-check">
              <input className="form-check-input" type="checkbox" id={`tipoPagamentoUsuario_${it.value}`}
                checked={tiposPagamentoSelecionados.includes(it.value)}
                onChange={e => this.handleTipoPagamentoChange(it.value, e.target.checked)} />
              <label className="form-check-label" htmlFor={`tipoPagamentoUsuario_${it.value}`}>{it.label}</label>
            </div>
          ))}
          <button type="button" className="vx-btn-incluir" style={{ marginLeft: 'auto' }}
            disabled={!usuarioEmpresaSelecionado || tiposPagamentoSelecionados.length === 0}
            onClick={() => this.incluirUsuario()}>
            <i className="material-icons" style={{ fontSize: 14 }}>add</i> Incluir
          </button>
        </div>
        <div className="vx-item-list">
          {usuariosConfigurados.length === 0
            ? <div className="vx-item-list-empty">Nenhum usuário incluído</div>
            : usuariosConfigurados.map(it => (
              <div key={it.usuarioEmpresaId} className="vx-item-list-item">
                <div className="vx-item-list-item-info">
                  <span className="vx-item-list-item-label">{it.descricaoUsuario}</span>
                  <span className="vx-item-list-item-sub">{descricaoFormasPagamento(it.tiposPagamento)}</span>
                </div>
                <button type="button" className="vx-item-list-remove" title="Remover usuário"
                  onClick={() => this.removerUsuario(it.usuarioEmpresaId)}>
                  <i className="material-icons" style={{ fontSize: 16 }}>close</i>
                </button>
              </div>
            ))}
        </div>
      </div>
    );
  }

  // Recarrega as rotas da empresa (combo) e as rotas já configuradas (tabela) a cada abertura
  carregarRotas() {
    const empresaId = this.props.codigoEmpresaSelecionada;
    this.setState({ rotasEmpresa: [], rotaSelecionada: null, tiposPagamentoRota: [], rotasConfiguradas: [] });
    if (!empresaId) {
      return;
    }
    this.props.buscarRotas(empresaId, null, null, null, true)
      .then(response => {
        // A API devolve { rotas: [...] } (mesmo formato lido em state.rotas.rotas no Gerenciar Itinerários)
        const rotas = (response.payload.data || {}).rotas;
        this.setState({ rotasEmpresa: Array.isArray(rotas) ? rotas : [] });
      })
      .catch(() => {
        // mensagem de erro já exibida pelo interceptor de resposta
      });
    this.props.buscarRotasControleEmissaoBpe(empresaId)
      .then(response => {
        const data = response.payload.data || [];
        this.setState({
          rotasConfiguradas: Array.isArray(data) ? data.map(it => ({
            rotaId: it.rotaId,
            descricaoRota: it.descricaoRota,
            tiposPagamento: it.tiposPagamento || []
          })) : []
        });
      })
      .catch(() => {
        // mensagem de erro já exibida pelo interceptor de resposta
      });
  }

  alterarTipoPagamentoRota(tipoPagamento, checked) {
    const tiposPagamentoRota = checked
      ? [...this.state.tiposPagamentoRota, tipoPagamento]
      : this.state.tiposPagamentoRota.filter(it => it !== tipoPagamento);
    this.setState({ tiposPagamentoRota });
  }

  incluirRota() {
    const { rotaSelecionada, tiposPagamentoRota, rotasConfiguradas } = this.state;
    if (!rotaSelecionada) {
      showAlertMsg('Selecione uma rota.');
      return;
    }
    if (tiposPagamentoRota.length === 0) {
      showAlertMsg('Selecione ao menos uma forma de pagamento.');
      return;
    }
    const novaRota = {
      rotaId: rotaSelecionada.value,
      descricaoRota: rotaSelecionada.descricao,
      tiposPagamento: [...tiposPagamentoRota]
    };
    const jaIncluida = rotasConfiguradas.some(it => it.rotaId === novaRota.rotaId);
    this.setState({
      rotasConfiguradas: jaIncluida
        ? rotasConfiguradas.map(it => (it.rotaId === novaRota.rotaId ? novaRota : it))
        : [...rotasConfiguradas, novaRota],
      rotaSelecionada: null,
      tiposPagamentoRota: []
    });
    if (jaIncluida) {
      showSuccessMsg('Rota já incluída: formas de pagamento atualizadas.');
    }
  }

  removerRota(rotaId) {
    this.setState({ rotasConfiguradas: this.state.rotasConfiguradas.filter(it => it.rotaId !== rotaId) });
  }

  carregarDiasSemana() {
    const empresaId = this.props.codigoEmpresaSelecionada;
    this.setState({ diasSemana: [], novosHorarios: {} });
    if (!empresaId) {
      return;
    }
    this.props.buscarDiasSemanaControleEmissaoBpe(empresaId)
      .then(response => {
        const data = response.payload.data || [];
        this.setState({ diasSemana: Array.isArray(data) ? data : [] });
      })
      .catch(() => {
        // mensagem de erro já exibida pelo interceptor de resposta
      });
  }

  selecionarDia(dia) {
    const { diasSemana } = this.state;
    if (diasSemana.some(it => it.diaSemana === dia)) {
      this.setState({ diasSemana: diasSemana.filter(it => it.diaSemana !== dia) });
    } else {
      const novaLista = [...diasSemana, { diaSemana: dia, horarios: [] }]
        .sort((a, b) => ordemDia(a.diaSemana) - ordemDia(b.diaSemana));
      this.setState({ diasSemana: novaLista });
    }
  }

  alterarNovoHorario(dia, campo, valor) {
    const novosHorarios = { ...this.state.novosHorarios };
    novosHorarios[dia] = { ...novosHorarios[dia], [campo]: valor };
    this.setState({ novosHorarios });
  }

  incluirHorario(dia) {
    const novo = this.state.novosHorarios[dia] || {};
    if (!novo.horaInicio || !novo.horaFim) {
      showAlertMsg('Informe a hora início e a hora fim.');
      return;
    }
    if (novo.horaInicio >= novo.horaFim) {
      showAlertMsg('A hora início deve ser menor que a hora fim.');
      return;
    }
    const diasSemana = this.state.diasSemana.map(it => {
      if (it.diaSemana !== dia) {
        return it;
      }
      if (it.horarios.some(h => h.horaInicio === novo.horaInicio && h.horaFim === novo.horaFim)) {
        return it;
      }
      const horarios = [...it.horarios, { horaInicio: novo.horaInicio, horaFim: novo.horaFim }]
        .sort((a, b) => a.horaInicio.localeCompare(b.horaInicio));
      return { ...it, horarios };
    });
    const novosHorarios = { ...this.state.novosHorarios };
    delete novosHorarios[dia];
    this.setState({ diasSemana, novosHorarios });
  }

  removerHorario(dia, indice) {
    const diasSemana = this.state.diasSemana.map(it => (it.diaSemana === dia
      ? { ...it, horarios: it.horarios.filter((h, i) => i !== indice) }
      : it));
    this.setState({ diasSemana });
  }

  replicarHorarios(dia) {
    const origem = this.state.diasSemana.find(it => it.diaSemana === dia);
    const diasSemana = this.state.diasSemana.map(it => ({ ...it, horarios: [...origem.horarios] }));
    this.setState({ diasSemana });
    showSuccessMsg('Horários replicados para os demais dias selecionados.');
  }

  limparFormulario() {
    this.props.reset('formularioPainelRegraControleEmissaoBpe');
    this.setState({
      usuarioEmpresaSelecionado: null,
      tiposPagamentoSelecionados: [],
      usuarios: [],
      diasSemana: [],
      novosHorarios: {},
      rotasEmpresa: [],
      rotaSelecionada: null,
      tiposPagamentoRota: [],
      rotasConfiguradas: [],
      usuariosConfigurados: [],
      usuariosOriginais: []
    });
  }

  limparCampos() {
    this.props.limparCheckedTipoControle();
    this.setState({
      usuarioEmpresaSelecionado: null,
      tiposPagamentoSelecionados: [],
      usuarios: []
    });
  }

  buscarUsuarios(inputValue) {
    if (!inputValue || inputValue.length < 2) {
      this.setState({ usuarios: [] });
      return;
    }

    const empresaId = this.props.codigoEmpresaSelecionada;
    if (!empresaId) {
      return;
    }

    this.setState({ carregandoUsuarios: true });
    this.props.buscarUsuarioPorEmpresaNomeIdEmail(inputValue, empresaId)
      .then(response => {
        const data = response.payload.data || [];
        const usuarios = Array.isArray(data) ? data.map(ue => {
          const usuarioEmpresaId = ue.usuarioEmpresaId || ue.id;
          return {
            value: usuarioEmpresaId,
            label: `${ue.nome || ''} (${ue.email || ''})`
          };
        }).filter(u => u.value) : [];
        this.setState({ usuarios, carregandoUsuarios: false });
      })
      .catch(() => {
        this.setState({ carregandoUsuarios: false });
      });
  }

  handleUsuarioChange(selectedOption) {
    if (selectedOption && selectedOption.value) {
      this.setState({ usuarioEmpresaSelecionado: selectedOption });
    } else {
      this.setState({ usuarioEmpresaSelecionado: null });
    }
  }

  handleTipoPagamentoChange(tipoPagamento, checked) {
    const tiposPagamento = [...this.state.tiposPagamentoSelecionados];
    if (checked) {
      if (!tiposPagamento.includes(tipoPagamento)) {
        tiposPagamento.push(tipoPagamento);
      }
    } else {
      const index = tiposPagamento.indexOf(tipoPagamento);
      if (index > -1) {
        tiposPagamento.splice(index, 1);
      }
    }
    this.setState({ tiposPagamentoSelecionados: tiposPagamento });
  }

  submit() {
    if (this.props.tipoControleBpeSelecionado === tipoControleEmissaoBPe.porUsuario.value) {
      if (this.state.usuariosConfigurados.length === 0) {
        showAlertMsg('Inclua ao menos um usuário.');
        return;
      }
      if (this.state.usuarioEmpresaSelecionado) {
        showAlertMsg('Há um usuário selecionado e não incluído. Clique em Incluir ou limpe a seleção.');
        return;
      }
    }

    if (this.props.tipoControleBpeSelecionado === tipoControleEmissaoBPe.diaEHorario.value) {
      if (this.state.diasSemana.length === 0) {
        showAlertMsg('Selecione ao menos um dia da semana.');
        return;
      }
      const diaComHorarioPendente = this.state.diasSemana.find(it => {
        const novo = this.state.novosHorarios[it.diaSemana];
        return novo && (novo.horaInicio || novo.horaFim);
      });
      if (diaComHorarioPendente) {
        const dia = DIAS_SEMANA.find(it => it.value === diaComHorarioPendente.diaSemana);
        showAlertMsg(`Há um horário preenchido e não incluído em ${dia.descricao}. Clique em Incluir ou limpe os campos.`);
        return;
      }
    }

    if (this.props.tipoControleBpeSelecionado === tipoControleEmissaoBPe.porRotaFormaPagamento.value) {
      if (this.state.rotasConfiguradas.length === 0) {
        showAlertMsg('Inclua ao menos uma rota.');
        return;
      }
      if (this.state.rotaSelecionada) {
        showAlertMsg('Há uma rota selecionada e não incluída. Clique em Incluir ou limpe a seleção.');
        return;
      }
    }

    // Salvar regra primeiro
    this.props.cadastrarRegraControleEmissaoBpe(this.montarParametroControle()).then(() => {
      // Se for POR_USUARIO, exclui os que saíram da lista e grava os usuários da lista
      if (this.props.tipoControleBpeSelecionado === tipoControleEmissaoBPe.porUsuario.value) {
        const { usuariosConfigurados, usuariosOriginais } = this.state;
        const removidos = usuariosOriginais
          .filter(original => !usuariosConfigurados.some(it => it.usuarioEmpresaId === original.usuarioEmpresaId));
        return Promise.all(removidos.map(it => this.props.excluirControleEmissaoBpeUsuario(it.id)))
          .then(() => Promise.all(usuariosConfigurados.map(it => this.props.cadastrarControleEmissaoBpeUsuario({
            usuarioEmpresaId: it.usuarioEmpresaId,
            tiposPagamento: it.tiposPagamento
          }))))
          .then(() => {
          showSuccessMsg('Regra e configuração de usuário salvas com sucesso');
          this.limparCampos();
          this.props.buscarConfiguracoesBPe();
          this.props.buscarEmpresaPorId(this.props.codigoEmpresaSelecionada);
          if (this.props.listarControlesUsuario) {
            this.props.listarControlesUsuario();
          }
          this.fecharModal();
        }).catch(error => {
          if (error.response && error.response.data && error.response.data.message) {
            showAlertMsg(error.response.data.message);
          } else {
            showAlertMsg('Erro ao salvar configuração do usuário.');
          }
        });
      } else {
        showSuccessMsg('Regra Controle Emissao Bpe salva com sucesso');
        this.limparCampos();
        this.props.buscarConfiguracoesBPe();
        this.props.buscarEmpresaPorId(this.props.codigoEmpresaSelecionada);
        this.fecharModal();
      }
    }).catch(() => {
      // mensagem de erro já exibida pelo interceptor de resposta
    });
  }

  fecharModal() {
    $('#modalPainelRegraControleEmissaoBpe')
      .modal('hide');
    $('#modalPainelRegraControleEmissaoBpe')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.limparFormulario();
  }

  montarParametroControle() {
    const parametro = {
      idEmpresa: this.props.codigoEmpresaSelecionada,
      tipoControleEmissaoBPe: this.props.tipoControleBpeSelecionado
    };
    if (this.props.tipoControleBpeSelecionado === tipoControleEmissaoBPe.diaEHorario.value) {
      parametro.diasSemana = this.state.diasSemana;
    }
    if (this.props.tipoControleBpeSelecionado === tipoControleEmissaoBPe.porRotaFormaPagamento.value) {
      parametro.rotas = this.state.rotasConfiguradas.map(it => ({ rotaId: it.rotaId, tiposPagamento: it.tiposPagamento }));
    }
    return parametro;
  }

  exibirConfiguracaoDiaHorario() {
    const { diasSemana, novosHorarios } = this.state;
    return (
      <div className="vx-modal-section">
        <div className="vx-modal-section-title">
          <i className="material-icons">date_range</i>Dias e Horários
        </div>
        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Dias da semana</label>
        <div className="vx-days-row">
          {DIAS_SEMANA.map(it => (
            <button key={it.value} type="button"
              className={`vx-day-btn${diasSemana.some(d => d.diaSemana === it.value) ? ' vx-day-btn--active' : ''}`}
              onClick={() => this.selecionarDia(it.value)}>
              {it.label}
            </button>
          ))}
        </div>
        {diasSemana.length === 0 && (
          <span style={{ fontSize: 11, color: '#dc3545', display: 'block', marginTop: 4 }}>
            Selecione ao menos um dia
          </span>
        )}
        {diasSemana.length > 0 && (
          <span style={{ fontSize: 11, color: '#888', display: 'block', marginTop: 4 }}>
            Horários são opcionais: dia sem horário transmite o BPe o dia inteiro.
          </span>
        )}
        <div className="vx-item-list">
          {diasSemana.map(dia => {
            const infoDia = DIAS_SEMANA.find(it => it.value === dia.diaSemana);
            const novo = novosHorarios[dia.diaSemana] || {};
            return (
              <div key={dia.diaSemana} className="vx-item-list-item" style={{ flexDirection: 'column', alignItems: 'stretch' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                  <span className="vx-item-list-item-label">{infoDia.descricao}</span>
                  {diasSemana.length > 1 && (
                    <button type="button" className="btn btn-link btn-sm p-0" style={{ fontSize: 12 }}
                      onClick={() => this.replicarHorarios(dia.diaSemana)}>
                      Replicar horários para os demais dias
                    </button>
                  )}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, margin: '6px 0' }}>
                  {dia.horarios.length === 0
                    ? <span className="vx-item-list-item-sub">Dia inteiro</span>
                    : dia.horarios.map((h, i) => (
                      <span key={`${h.horaInicio}-${h.horaFim}`}
                        style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: '#fff', border: '1px solid #ddd', borderRadius: 12, padding: '2px 8px', fontSize: 12 }}>
                        {h.horaInicio} - {h.horaFim}
                        <button type="button" className="vx-item-list-remove" title="Remover horário"
                          onClick={() => this.removerHorario(dia.diaSemana, i)}>
                          <i className="material-icons" style={{ fontSize: 14 }}>close</i>
                        </button>
                      </span>
                    ))}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'flex-end' }}>
                  <div>
                    <label style={{ fontSize: 11, color: '#555', display: 'block', marginBottom: 2 }}>Hora início</label>
                    <input type="time" className="form-control form-control-sm" value={novo.horaInicio || ''}
                      onChange={e => this.alterarNovoHorario(dia.diaSemana, 'horaInicio', e.target.value)} />
                  </div>
                  <div>
                    <label style={{ fontSize: 11, color: '#555', display: 'block', marginBottom: 2 }}>Hora fim</label>
                    <input type="time" className="form-control form-control-sm" value={novo.horaFim || ''}
                      onChange={e => this.alterarNovoHorario(dia.diaSemana, 'horaFim', e.target.value)} />
                  </div>
                  <button type="button" className="vx-btn-incluir" style={{ height: 31 }}
                    onClick={() => this.incluirHorario(dia.diaSemana)}>
                    <i className="material-icons" style={{ fontSize: 14 }}>add</i> Incluir
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // Somente exibição: os horários são cadastrados em "Cadastrar Emissão BPe em Lote" ou na linha de cada configuração
  exibirHorariosSalvos() {
    const configuracoes = (Array.isArray(this.props.configuracoesBPe) ? this.props.configuracoesBPe : [])
      .filter(it => it.controlesEmissaoBpe && it.controlesEmissaoBpe.length > 0)
      .sort((a, b) => (Number(b.seAtivo) - Number(a.seAtivo))
        || ((a.endereco && a.endereco.uf) || '').localeCompare((b.endereco && b.endereco.uf) || ''));
    return (
      <div className="vx-modal-section">
        <div className="vx-modal-section-title">
          <i className="material-icons">schedule</i>Horários Cadastrados
        </div>
        <div className="vx-item-list">
          {configuracoes.length === 0
            ? <div className="vx-item-list-empty">Nenhum horário cadastrado</div>
            : configuracoes.map(config => (
              <div key={config.id} className="vx-item-list-item">
                <div className="vx-item-list-item-info">
                  <span className="vx-item-list-item-label">{config.endereco && config.endereco.uf}</span>
                  <span style={{ fontSize: 10, fontWeight: 600, color: config.seAtivo ? '#28a745' : '#dc3545' }}>
                    {config.seAtivo ? 'ATIVA' : 'INATIVA'}
                  </span>
                  <span className="vx-item-list-item-sub">
                    {[...config.controlesEmissaoBpe]
                      .sort((a, b) => a.horaInicio.localeCompare(b.horaInicio))
                      .map(it => `${it.horaInicio} - ${it.horaFim}`)
                      .join('  |  ')}
                  </span>
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }

  exibirConfiguracaoRotaFormaPagamento() {
    const { rotasEmpresa, rotaSelecionada, tiposPagamentoRota, rotasConfiguradas } = this.state;
    return (
      <div className="vx-modal-section">
        <div className="vx-modal-section-title">
          <i className="material-icons">alt_route</i>Rotas e Formas de Pagamento
        </div>
        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Rota</label>
        <Select
          maxMenuHeight={200}
          menuPlacement="auto"
          noOptionsMessage={() => ('Nenhuma opção encontrada')}
          placeholder='Selecione uma rota...'
          options={rotasEmpresa.map(elemento => ({
            label: `${elemento.id}: ${elemento.descricao}`,
            value: elemento.id,
            descricao: elemento.descricao
          }))}
          value={rotaSelecionada}
          onChange={value => this.setState({ rotaSelecionada: value })}
        />
        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', margin: '12px 0 4px' }}>Formas de pagamento que emitem BPe</label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center' }}>
          {FORMAS_PAGAMENTO_ROTA.map(it => (
            <div key={it.value} className="form-check">
              <input className="form-check-input" type="checkbox" id={`tipoPagamentoRota_${it.value}`}
                checked={tiposPagamentoRota.includes(it.value)}
                onChange={e => this.alterarTipoPagamentoRota(it.value, e.target.checked)} />
              <label className="form-check-label" htmlFor={`tipoPagamentoRota_${it.value}`}>{it.label}</label>
            </div>
          ))}
          <button type="button" className="vx-btn-incluir" style={{ marginLeft: 'auto' }}
            disabled={!rotaSelecionada || tiposPagamentoRota.length === 0}
            onClick={() => this.incluirRota()}>
            <i className="material-icons" style={{ fontSize: 14 }}>add</i> Incluir
          </button>
        </div>
        <div className="vx-item-list">
          {rotasConfiguradas.length === 0
            ? <div className="vx-item-list-empty">Nenhuma rota incluída</div>
            : rotasConfiguradas.map(it => (
              <div key={it.rotaId} className="vx-item-list-item">
                <div className="vx-item-list-item-info">
                  <span className="vx-item-list-item-label">{`${it.rotaId}: ${it.descricaoRota || ''}`}</span>
                  <span className="vx-item-list-item-sub">{descricaoFormasPagamento(it.tiposPagamento)}</span>
                </div>
                <button type="button" className="vx-item-list-remove" title="Remover rota"
                  onClick={() => this.removerRota(it.rotaId)}>
                  <i className="material-icons" style={{ fontSize: 16 }}>close</i>
                </button>
              </div>
            ))}
        </div>
      </div>
    );
  }

  exibirIconeAjudaRegra(tipoControle, tooltipId, tooltipContent) {
    return (
      <span className="align-self-center tooltip-info">
        <a data-tip data-for={tooltipId}>
          <i className="material-icons ajuda-icon" style={{ color: '#000' }}>help</i>
        </a>
        <div className="tooltip-ut">
          <ReactTooltip className="tooltip-ut" id={tooltipId} type="dark" effect="solid">
            <div className="row">{tooltipContent}</div>
          </ReactTooltip>
        </div>
      </span>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="modal fade show" id='modalPainelRegraControleEmissaoBpe' role='dialog'
        aria-labelledby='modalPainelRegraControleEmissaoBpe' aria-hidden='true' data-backdrop='static'>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content vx-modal-content">
            <div className="vx-modal-header">
              <div className="vx-modal-header-left">
                <i className="material-icons">tune</i>
                <span className="vx-modal-title">Painel Selecionar Regra Controle Emissão BPe</span>
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal"
                onClick={this.limparFormulario}>
                <i className="material-icons">close</i>
              </button>
            </div>
            <form onSubmit={handleSubmit(this.submit)}>
              <div className="vx-modal-body">
                <div className="vx-modal-section">
                  <div className="vx-modal-section-title">
                    <i className="material-icons">settings</i>Tipo de Controle de Emissão BPe
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.padrao.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.padrao.value)}
                      value={tipoControleEmissaoBPe.padrao.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.padrao.value} />
                    <label htmlFor={tipoControleEmissaoBPe.padrao.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.padrao.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.padrao.value, 'regraPadrao', 'Configuração original existente, respeitando ativo e inativo empresa e estados.')}
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.horario.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.horario.value)}
                      value={tipoControleEmissaoBPe.horario.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.horario.value} />
                    <label htmlFor={tipoControleEmissaoBPe.horario.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.horario.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.horario.value, 'regraHorario', 'Será transmitido somente nos horários marcados na tabela.')}
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.cartao.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.cartao.value)}
                      value={tipoControleEmissaoBPe.cartao.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.cartao.value} />
                    <label htmlFor={tipoControleEmissaoBPe.cartao.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.cartao.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.cartao.value, 'regraCartao', 'Transmitir BPe em todas vendas de cartão.')}
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.horarioMaisCartao.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.horarioMaisCartao.value)}
                      value={tipoControleEmissaoBPe.horarioMaisCartao.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.horarioMaisCartao.value} />
                    <label htmlFor={tipoControleEmissaoBPe.horarioMaisCartao.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.horarioMaisCartao.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.horarioMaisCartao.value, 'regrahorarioMaisCartao', 'Quando a regra do temporizador estiver ativa, se vender no cartão Independente do horário ela vai transmitir o bpe na venda.')}
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.tef.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.tef.value)}
                      value={tipoControleEmissaoBPe.tef.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.tef.value} />
                    <label htmlFor={tipoControleEmissaoBPe.tef.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.tef.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.tef.value, 'regraTef', 'Transmitir BPe em todas vendas de TEF.')}
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.porUsuario.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.porUsuario.value)}
                      value={tipoControleEmissaoBPe.porUsuario.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.porUsuario.value} />
                    <label htmlFor={tipoControleEmissaoBPe.porUsuario.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.porUsuario.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.porUsuario.value, 'regraPorUsuario', 'Emite BPE baseado na configuração específica de cada usuário da empresa.')}
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.diaEHorario.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.diaEHorario.value)}
                      value={tipoControleEmissaoBPe.diaEHorario.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.diaEHorario.value} />
                    <label htmlFor={tipoControleEmissaoBPe.diaEHorario.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.diaEHorario.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.diaEHorario.value, 'regraDiaEHorario', 'Transmite BPe somente nos dias da semana selecionados. Se o dia tiver horários vinculados, transmite apenas dentro deles; sem horários, transmite o dia inteiro.')}
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.porRotaFormaPagamento.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.porRotaFormaPagamento.value)}
                      value={tipoControleEmissaoBPe.porRotaFormaPagamento.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.porRotaFormaPagamento.value} />
                    <label htmlFor={tipoControleEmissaoBPe.porRotaFormaPagamento.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.porRotaFormaPagamento.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.porRotaFormaPagamento.value, 'regraPorRotaFormaPagamento', 'Transmite BPe somente nas rotas incluídas e quando o pagamento for uma das formas marcadas para a rota.')}
                  </div>
                </div>

                {ehRegraHorario(this.props.tipoControleBpeSelecionado) && this.exibirHorariosSalvos()}

                {this.props.tipoControleBpeSelecionado === tipoControleEmissaoBPe.diaEHorario.value && this.exibirConfiguracaoDiaHorario()}

                {this.props.tipoControleBpeSelecionado === tipoControleEmissaoBPe.porRotaFormaPagamento.value && this.exibirConfiguracaoRotaFormaPagamento()}

                {this.props.tipoControleBpeSelecionado === tipoControleEmissaoBPe.porUsuario.value && this.exibirConfiguracaoPorUsuario()}
              </div>
              <div className="vx-modal-footer">
                <button type="submit"
                  disabled={!this.props.tipoControleBpeSelecionado}
                  className="vx-btn-primary">
                  <i className="material-icons">save</i>
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const empresaSelecionada = state.empresaSelecionada;
  return {
    tipoControle: formValueSelector('formularioPainelRegraControleEmissaoBpe')(state, 'tipoControle'),
    configuracoesBPe: state.configuracaoBPe.configuracoesBPe,
    // Prioriza a empresa da tela (codigoEmpresa da URL); a do cabeçalho pode ser outra quando o admin vem de Gerenciar Empresas
    codigoEmpresaSelecionada: ownProps.codigoEmpresaSelecionada || empresaSelecionada?.empresa?.id || empresaSelecionada?.id || null
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarRegraControleEmissaoBpe,
    buscarEmpresaPorId,
    cadastrarControleEmissaoBpeUsuario,
    listarControleEmissaoBpeUsuario,
    excluirControleEmissaoBpeUsuario,
    buscarUsuarioPorEmpresaNomeIdEmail,
    buscarDiasSemanaControleEmissaoBpe,
    buscarRotasControleEmissaoBpe,
    buscarRotas
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioPainelRegraControleEmissaoBpe'
})(ModalPainelRegraControleEmissaoBpe));